import { Card } from '@/components/ui/card';
import DateRangePicker from '@/components/filters/DateRangePicker';

const ApiDiagnosticsPage = () => (
  <div className="space-y-6">
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div>
        <h2 className="text-2xl font-semibold text-white">API Diagnostics</h2>
        <p className="text-sm text-slate-400">Latency percentiles, error budgets, and recent failures.</p>
      </div>
      <DateRangePicker />
    </div>

    <div className="grid gap-4 lg:grid-cols-2">
      <Card title="Latency Percentiles">
        <p className="text-sm text-slate-400">Visualize p50/p95/p99 from `mv_api_health_daily`.</p>
      </Card>
      <Card title="Error Rate">
        <p className="text-sm text-slate-400">Stacked area or line chart using `error_rate` field.</p>
      </Card>
    </div>

    <Card title="Recent Errors">
      <p className="text-sm text-slate-400">Table showing route, status, error message, and occurred_at.</p>
    </Card>
  </div>
);

export default ApiDiagnosticsPage;
